export default {
      id: "circle-survey-type-q-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-survey-type-q-usage",
      toString: function () {
        return this.url;
      }
    }